/**
 * FavouritesProvider
 * Contain most logic handing with Omnitech Api
 */

import React from 'react'
import FavouritesContext from './favourites-context'
import { fetchFavourites, createFavourite } from './favourites-api'

export default function FavouritesProvider({ children }) {
  const state = {
    fetchFavourites,
    createFavourite: id => createFavourite(id, true),
    deleteFavourite: id => createFavourite(id, false)
  }
  return (
    <FavouritesContext.Provider value={state}>
      {children}
    </FavouritesContext.Provider>
  )
}
